<template>
  <div class="platform-transfer">
    <Header :back-to-home="true" :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="layout">
        <div class="select-account-group">
          <div class="select-account-container">
            <SelectAccount
              :acc-type-txt="'转账'"
              :current-acc="fromAccount"
              :acc-list="accTradeInfoList"
              :disable-session-platform="true"
              :disabled="isSelectAccountDisabled()"
              @onConfirmAccount="onConfirmToAccount"
            />
            <p class="balance">目前余额: ${{ fromAccount ? fromAccount.balance : '0.00' }}</p>
          </div>
          <div class="select-account-container">
            <SelectAccount
              :acc-type-txt="'收账'"
              :current-acc="toAccount"
              :acc-list="accTradeInfoList"
              :disable-session-platform="true"
              :disabled="isSelectAccountDisabled()"
              @onConfirmAccount="onConfirmFromAccount"
            />
            <p class="balance">目前余额: ${{ toAccount ? toAccount.balance : '0.00' }}</p>
          </div>
        </div>
        <div class="amount">
          <div
            class="w_title"
          >
            <span>转账金额（美元）</span>
          </div>
          <div class="inputAmount">
            <span>$</span>
            <input
              v-model="amount"
              type="number"
              min="0"
              :placeholder="`最多可转 $${advisableCreditAmount}`"
            >
            <p @click="allTransfer">全部转账</p>
          </div>
          <div
            :class="{'suc': Number(amount) > 0}"
            class="submit"
            @click="submit"
          >
            <p>转账</p>
          </div>
        </div>

      </div>
    </div>
    <Chat />
  </div>
</template>

<script>
require('@/assets/css/platformTransfer.css')
import Header from '@/view/module/Header.vue'
import SelectAccount from '@/view/module/SelectAccount.vue'
import { mapState } from 'vuex'
import api from '@/plugins/api'
import Chat from '@/view/module/Chat.vue'

export default {
  name: 'PlatformTransfer',
  components: { Header, SelectAccount, Chat },
  computed: {
    ...mapState(['gts2AccountId', 'gts2CustomerId', 'platform'])
  },
  data() {
    return {
      title: '转账',
      rightContent: 'transfer',
      accTradeInfoList: [],
      fromAccount: null,
      toAccount: null,
      amount: '',
      advisableCreditAmount: 0,
      fromPlatform: this.$route.query.fromPlatform
    }
  },
  mounted() {
    this.getAccTradeInfo()
  },
  methods: {
    getAccTradeInfo() {
      this.$bus.$emit('loading', false)
      api.getAccTradeInfo(this.gts2CustomerId).then(res => {
        if (res.data.code == 200) {
          this.accTradeInfoList = res.data.data.accTradeInfoList

          const accountsWithZeroBalance = this.accTradeInfoList.filter(account => account.balance == 0)

          if (accountsWithZeroBalance.length == 1) {
            this.toAccount = accountsWithZeroBalance[0]
            this.fromAccount = this.accTradeInfoList.find(account => account.balance != 0)
          } else {
            if (this.fromPlatform) {
              this.toAccount = this.accTradeInfoList.find(account => account.platform != this.fromPlatform)
              this.fromAccount = this.accTradeInfoList.find(account => account.platform == this.fromPlatform)
            } else {
              this.toAccount = this.accTradeInfoList[1]
              this.fromAccount = this.accTradeInfoList[0]
            }
          }

          this.$store.dispatch('setPlatform', this.fromAccount.platform)
          this.$store.dispatch('setPlatformName', this.fromAccount.platformName)
          this.$store.dispatch('setGts2AccountId', this.fromAccount.gts2AccountId)

          this.getAdvisableCredit()
        }
      })
    },
    getAdvisableCredit() {
      api.getAdvisableCredit(this.fromAccount.gts2AccountId).then((res) => {
        this.$bus.$emit('loading', true)
        if (res.status) {
          if (res.data.code == 200) {
            this.advisableCreditAmount = res.data.data.advisableCredit
          }
        }
      })
    },
    onConfirmToAccount(account) {
      this.toAccount = this.fromAccount
      this.fromAccount = account

      this.$store.dispatch('setPlatform', this.fromAccount.platform)
      this.$store.dispatch('setPlatformName', this.fromAccount.platformName)
      this.$store.dispatch('setGts2AccountId', this.fromAccount.gts2AccountId)

      this.$bus.$emit('loading', false)
      this.getAdvisableCredit()
    },
    onConfirmFromAccount(account) {
      this.fromAccount = this.toAccount
      this.toAccount = account

      this.$store.dispatch('setPlatform', this.fromAccount.platform)
      this.$store.dispatch('setPlatformName', this.fromAccount.platformName)
      this.$store.dispatch('setGts2AccountId', this.fromAccount.gts2AccountId)

      this.$bus.$emit('loading', false)
      this.getAdvisableCredit()
    },
    allTransfer() {
      this.amount = this.advisableCreditAmount
    },
    submit() {
      const transferData = {
        fromAccount: this.fromAccount,
        toAccount: this.toAccount,
        amount: this.amount
      }

      this.$store.dispatch('setTransferData', transferData)
      this.$router.push({ path: '/home/platformTransferConfirm' })
    },
    isSelectAccountDisabled() {
      return this.toAccount ? this.toAccount.balance == 0 : false
    }
  }
}
</script>
